import Div from '@jumbo/shared/Div'
import { Timeline, TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineSeparator } from '@mui/lab'
import { Box, Table, TableBody, TableHead, TableRow, Tooltip, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import JumboScrollbar from '@jumbo/components/JumboScrollbar'
import { format } from 'date-fns'
import PropTypes from 'prop-types'
import { useCompanyData } from './CompanyDataProvider'

const WorkflowApproverStatus = ({ WorkflowName, partnerId, scrollHeight, approvalStatus, HeadApproverName }) => {

    const { dateFormat, workflows, fetchApprovalData, flagOfHeadApprover } = useCompanyData();

    const headApproverName = localStorage.getItem("ReportHeadName");


    const TimelineItemComponent = ({ approverName, status = "Pending", time = "-", comment = "-" }) => {
        return (
            <Timeline sx={{ pr: 0.5, pl: 1, mb: 0 }}>
                <TimelineItem sx={{ "&::before": { display: "none" } }}>
                    <TimelineSeparator sx={{ mb: -4 }}>
                        <TimelineDot
                            sx={{
                                m: (theme) => theme.spacing(0.5, 0),
                                width: 14,
                                height: 14,
                                bgcolor: "#F39711",
                                color: "#017890",
                                mb: 0.5,
                                boxShadow:
                                    "0 0 0 4px #fff,inset 0 2px 0 rgba(0,0,0,.08),0 3px 0 4px rgba(0,0,0,.05)",
                            }}
                        />
                        <TimelineConnector color="primary" />
                    </TimelineSeparator>
                    <TimelineContent sx={{ p: (theme) => theme.spacing(0.5, 0), ml: { xs: 3, md: 3 } }}>
                        <Div sx={{ display: "flex" }}>
                            <Typography
                                variant="h5"
                                data-title="Approver"
                                sx={{
                                    fontWeight: 400,
                                    minWidth: "145px",
                                    whiteSpace: approverName?.length > 15 ? "wrap" : "none",
                                }}
                            >
                                <Tooltip title={approverName} placement="right-end">
                                    <span>{approverName?.length > 15 ? `${approverName.slice(0, 15)}...` : approverName}</span>
                                </Tooltip>
                            </Typography>
                            <Typography
                                variant="h5"
                                className="pending-button"
                                data-title="Status"
                                sx={{ minWidth: "95px", ml: { xs: 1, md: 0 } }}
                            >
                                {status}
                            </Typography>
                            <Typography variant="h5" data-title="Time" sx={{ minWidth: "130px", textAlign: "left" }}>
                                {time}
                            </Typography>
                            <Typography
                                variant="h5"
                                data-title="Comment"
                                sx={{ minWidth: "140px", textAlign: "left", pl: 3 }}
                            >
                                {comment}
                            </Typography>
                        </Div>
                    </TimelineContent>
                </TimelineItem>
            </Timeline>
        );
    };

    const renderApproversTimeline = (workflows) => {
        return workflows?.map((option) => {
            const approvers = option?.Amountjosn?.map((opt) => opt);
            return approvers?.map((step, indx) => {
                return (
                    <Div key={step?.id}>
                        <TimelineItemComponent
                            approverName={step?.approver_name}
                            status="Pending"
                            time="-"
                            comment="-"
                        />
                    </Div>
                );
            });
        });
    };

    useEffect(() => {
        fetchApprovalData(WorkflowName, partnerId);
    }, [WorkflowName]);


    return (
        <>
            {approvalStatus ?
                <JumboScrollbar
                    autoHeight={true}
                    autoHideTimeout={4000}
                    autoHeightMin={scrollHeight || 300}
                    autoWidthMin={scrollHeight || { xs: 100, md: 400 }}
                    autoHide={true}
                    hideTracksWhenNotNeeded
                >
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: "#f5f7fa", position: "sticky", top: 0, zIndex: 10, opacity: 1 }}>
                            <TableRow sx={{ display: "flex", alignItems: "center", padding: "12px 0px 8px 0px", lineHeight: 2 }}>
                                <Div sx={{ display: "flex", }}>
                                    <Typography variant='h5' sx={{ textAlign: "center", color: "#017890", borderBottom: "0px solid #f5f7fa !important", minWidth: "210px", ml: -2.5 }}>Approver</Typography>
                                    <Typography variant='h5' sx={{ textAlign: "left", color: "#017890", borderBottom: "0px solid #f5f7fa !important", minWidth: "90px", maxWidth: "100px !important", width: "65px !important" }}>Status</Typography>
                                </Div>
                                <Div sx={{ display: "flex", }}>
                                    <Typography variant='h5' sx={{ textAlign: "left", color: "#017890", borderBottom: "0px solid #f5f7fa !important", minWidth: "145px" }}>Time</Typography>
                                    <Typography variant='h5' sx={{ textAlign: "left", color: "#017890", borderBottom: "0px solid #f5f7fa !important", minWidth: "170px" }}>Comment</Typography>
                                </Div>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                {approvalStatus?.length > 0 ?
                                    (
                                        <Div sx={{ minWidth: { md: "600px !important", display: "flex", flexWrap: "wrap" } }}>
                                            {approvalStatus && approvalStatus?.map((step, index) => (
                                                <div key={step?.id}>
                                                    <Timeline>
                                                        <TimelineItem
                                                            sx={{
                                                                "&::before": {
                                                                    display: "none",
                                                                },
                                                            }}
                                                            style={{ textAlign: "center" }}
                                                        >
                                                            <TimelineSeparator sx={{ mb: -4 }}>
                                                                <TimelineDot
                                                                    sx={{
                                                                        m: (theme) => theme.spacing(0.5, 0),
                                                                        width: 14,
                                                                        height: 14,
                                                                        mb: 0.5,
                                                                        bgcolor:
                                                                            step?.Approved_flg === true &&
                                                                                step?.status === true
                                                                                ? "#3BD2A2"
                                                                                : step?.Approved_flg === false &&
                                                                                    step?.status === true
                                                                                    ? "#E73145"
                                                                                    : "#F39711",
                                                                        color: "#017890",
                                                                        boxShadow:
                                                                            "0 0 0 4px #fff,inset 0 2px 0 rgba(0,0,0,.08),0 3px 0 4px rgba(0,0,0,.05)",
                                                                    }}
                                                                >
                                                                    {step.icon}
                                                                </TimelineDot>
                                                                {index !== approvalStatus?.length - 1 && (
                                                                    <TimelineConnector color="primary" />
                                                                )}
                                                            </TimelineSeparator>

                                                            <TimelineContent sx={{ ml: 1 }}>
                                                                <Div key={index} sx={{ display: "flex", }}>
                                                                    <Typography
                                                                        variant="h5"
                                                                        data-title="Approver"
                                                                        sx={{ fontWeight: 400, width: "135px", textWrap: "wrap", whiteSpace: step?.Approvername?.length > 10 ? "wrap" : "none" }}
                                                                    >
                                                                        {step?.Approvername}
                                                                    </Typography>

                                                                    {step?.Approved_flg === true &&
                                                                        step?.status === true ? (
                                                                        <Typography
                                                                            variant="h5"
                                                                            className="approve-button"
                                                                            data-title="Status"
                                                                            sx={{ minWidth: "90px", textAlign: "left", ml: { xs: 1, md: 0 } }}
                                                                        >
                                                                            Approved
                                                                        </Typography>
                                                                    ) : step?.Approved_flg === false &&
                                                                        step?.status === true ? (
                                                                        <Typography
                                                                            variant="h5"
                                                                            className="rejected-button"
                                                                            data-title="Status"
                                                                            sx={{ minWidth: "90px", textAlign: "left", ml: { xs: 1, md: 0 } }}
                                                                        >
                                                                            Rejected
                                                                        </Typography>
                                                                    ) : (
                                                                        <Typography
                                                                            variant="h5"
                                                                            className="pending-button"
                                                                            data-title="Status"
                                                                            sx={{ minWidth: "90px", textAlign: "left", ml: { xs: 1, md: 0 } }}
                                                                        >
                                                                            Pending
                                                                        </Typography>
                                                                    )}

                                                                    <Typography variant="h5" data-title="Time" sx={{ minWidth: "145px", textAlign: "left" }}>
                                                                        {step?.time ? step?.time && dateFormat ? `${format(
                                                                            new Date(step?.time),
                                                                            dateFormat
                                                                        )} ${new Date(
                                                                            step?.time
                                                                        ).getHours()}: ${new Date(
                                                                            step?.time
                                                                        ).getMinutes()}` : `${new Date(step?.time).getHours()} : ${new Date(step?.time).getMinutes()}` : '-'}
                                                                    </Typography>

                                                                    <Typography variant="h5" data-title="Comment" sx={{ minWidth: "180px", textAlign: "left", textWrap: "wrap" }}>
                                                                        {step?.comments ? step?.comments : '-'}
                                                                    </Typography>
                                                                </Div>
                                                            </TimelineContent>
                                                        </TimelineItem>
                                                    </Timeline>
                                                </div>
                                            ))}
                                        </Div>
                                    )
                                    :
                                    (
                                        <Div sx={{ minWidth: { md: "600px !important" } }}>
                                            {flagOfHeadApprover === true && (
                                                <Div>
                                                    <TimelineItemComponent
                                                        approverName={HeadApproverName || headApproverName}
                                                        status="Pending"
                                                        time="-"
                                                        comment="-"
                                                    />
                                                </Div>
                                            )}
                                            {renderApproversTimeline(workflows)}
                                        </Div>
                                    )
                                }
                            </TableRow>
                        </TableBody>
                    </Table>
                </JumboScrollbar>
                : (
                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        minHeight="280px"
                        style={{ backgroundColor: '#f5f5f5' }}
                    >
                        <Typography
                            variant="h5"
                            component="div"
                            style={{
                                color: '#333',
                                padding: '20px',
                                borderRadius: '8px',
                                backgroundColor: '#fff',
                                boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                            }}
                        >
                            Approver is not there.
                        </Typography>
                    </Box>
                )
            }
        </>
    )

}

WorkflowApproverStatus.propTypes = {
    WorkflowName: PropTypes.string,
    partnerId: PropTypes.number,
    scrollHeight: PropTypes.number,
    approvalStatus: PropTypes.array,
    HeadApproverName: PropTypes.string,
};

export default WorkflowApproverStatus;
